import { render, staticRenderFns } from "./RealtimeView.vue?vue&type=template&id=9a386040"
import script from "./RealtimeView.vue?vue&type=script&lang=js"
export * from "./RealtimeView.vue?vue&type=script&lang=js"
import style0 from "./RealtimeView.vue?vue&type=style&index=0&id=9a386040&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports